// Module
var code = `<p
  class="font-lusitana text-xl text-gray-800 md:text-3xl md:leading-normal"
>
  <strong>{{leadText}}</strong> {{bodyTextBefore}}<a
    href="{{attrLinkHref}}"
    class="text-blue-500"
    >{{linkText}}</a
  >{{bodyTextAfter}}
</p>
<a
  href="{{attrLoginHref}}"
  data-channel="ROUTE"
  data-page-id="login"
  data-event-prevent-default="true"
  class="flex items-center gap-5 self-start rounded-lg bg-blue-500 px-6 py-3 text-sm font-medium text-white transition-colors hover:bg-blue-400 md:text-base"
>
  <span>{{ctaText}}</span>
  {{svgArrowRight}}
</a>
`;
// Exports
module.exports = code;